import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';

import type { EmptyScreensBaseArgs } from 'webapp/components/empty-screens/base';
import EmptyScreensBaseComponent from 'webapp/components/empty-screens/base';

export default class EmptyScreensBoardsComponent extends EmptyScreensBaseComponent<EmptyScreensBaseArgs> {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('flow/tour/onboarding')
	declare flowTourOnboardingService: Service.Flow.Tour.Onboarding;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;

	trackingOrigin = 'databoards';

	constructor(owner: Owner, args: EmptyScreensBaseArgs) {
		super(owner, args);

		const _descText = "Always know how you're performing and make data-informed decisions. ";

		this.titleText = 'Build custom dashboards';
		this.descText =
			_descText +
			(this.isCurrentUserViewer ? 'There are currently no dashboards shared with you.' : '');

		this.topImageLightUrl = '/images/placeholders/boards.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/boards.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-boards.svg';

		this.mainActions = [
			{
				action: this.createBoardWizard,
				icon: 'Wizard',
				text: 'Use wizard',
			},
		];

		if (this.accountService.showPublicTemplates) {
			this.mainActions.push({
				action: this.openPublicTemplates,
				icon: 'FolderOpen',
				text: 'Use a template',
			});
		}

		this.arrowText = 'Select an option to get started with your first dashboard';
		this.isArrowInTheMiddle = true;
	}

	override get isNewSectionShown() {
		return this.isAnyActionShown && !this.mustUpgrade && !this.isCurrentUserViewer;
	}

	@action
	createBoardWizard() {
		this.mmBoardsService.openWizard();

		if (this.flowTourOnboardingService.isBannerShown) {
			this.flowTourOnboardingService.continueTour();
		}
	}

	@action
	openPublicTemplates() {
		this.analyticsService.event(TrackingEvent.DATABOARD_CREATED_NEW, {
			origin: 'public_template',
		});
		this.navigationService.transitionToRoute('boards.public-templates');
	}
}
